/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'help': {
    width: 16,
    height: 16,
    viewBox: '0 0 8 12.3',
    data: '<path pid="0" d="M5 9H3V6h1c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2H0c0-2.2 1.8-4 4-4s4 1.8 4 4c0 1.9-1.3 3.4-3 3.9V9z"/><circle pid="1" cx="4" cy="11" r="1.3"/>'
  }
})
